import React, { useEffect, useState } from "react";
import { useApplicationStateValue } from "../../../application/Application";
import TitleSeparator from "../../../components/title-separator/TitleSeparator";
import styled from "styled-components";
import PanelHeader from "../panel-header/PanelHeader";
import { Flex } from "reflexbox/styled-components";
import { Button, Input, Rate } from "antd";
import { Box } from "reflexbox/styled-components";
import { StarOutlined } from "@ant-design/icons";
import { strings } from "../../../languages/Localize";
import routes from "../../../config/routes";

const DivWithScrollY = styled(Flex)`
    height: 90%;
    overflow-y: auto;
    flex-direction: column;
`;

const StyledLabel = styled(Box)`
    font-size: ${({ theme }) => theme.fontSizes[3]}px;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    flex: 3;
    color: ${({ theme }) => theme.colors.white};
    height: ${({ theme }) => theme.sizes[1]}px;
`;

const StyledSendButton = styled(Button)`
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    flex: 1;
    text-align: center;
    padding: 0px;
`;

const StyledLabelAndSendButton = styled(Flex)`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
`;

const StyledQuestions = styled(Flex)`
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`;

const StyledQuestionText = styled(Box)`
    font-size: ${({ theme }) => theme.fontSizes[0]}px;
    font-weight: ${({ theme }) => theme.fontWeights.light};
    flex: 1;
    color: ${({ theme }) => theme.colors.white};
`;

const StyledQuestionRate = styled(Rate)`
    flex: 1;
`;

const StyledComment = styled(Input.TextArea)`
    font-size: ${({ theme }) => theme.fontSizes[1]}px;
    font-weight: ${({ theme }) => theme.fontWeights.light};
    color: ${({ theme }) => theme.colors.white};
    font-style: italic;
    resize: none;
    border: 0px;
    border-radius: 7px;
    background-color: ${({ theme }) => theme.colors.secondary};

    :disabled {
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
    }
`;

const PanelImpression = ({
    match: {
        params: { id }
    },
    history
}) => {
    const { appData, sendQuestionsAndComment, uuid } = useApplicationStateValue();

    const [questionsAndRating, setQuestionsAndRating] = useState([]);
    const [comment, setComment] = useState(null);
    const [disabledSendButton, setDisabledSendButton] = useState(true);

    const sendButtonListener = () => {
        const payload = {
            questions: questionsAndRating,
            comment: comment,
            guid: uuid
        };

        sendQuestionsAndComment(payload, id);
        history.push(routes.PANELS_IMPRESSION_DONE);
    };

    useEffect(() => {
        if (comment && comment.split(" ").join("") !== "") setDisabledSendButton(false);
        else setDisabledSendButton(true);
    }, [comment]);

    const changeRatingHandler = (questionId, rating, questionsLength) => {
        let questionsAndRatingCopy = [...questionsAndRating];
        let exists = false;
        questionsAndRatingCopy.forEach(questionAndRating => {
            if (questionAndRating.id === questionId) {
                exists = true;
                questionAndRating.rating = rating;
            }
        });

        if (exists === false) {
            questionsAndRatingCopy.push({
                id: questionId,
                rating: rating
            });
        }

        setQuestionsAndRating(questionsAndRatingCopy);
    };

    let panelImpression = null;
    if (appData !== null) {
        const { forumQuestions, forumPanels } = appData;
        const answers = forumPanels[id].impression.answers;
        const comment = forumPanels[id].impression.comment;

        const questions = forumQuestions.map(question => {
            return (
                <Box flex="1">
                    <StyledQuestionText>{question.text}</StyledQuestionText>
                    {answers ? (
                        <StyledQuestionRate
                            disabled="true"
                            value={answers[question.id]}
                            character={<StarOutlined />}
                            onChange={value => changeRatingHandler(question.id, value, forumQuestions.length)}
                        />
                    ) : (
                        <StyledQuestionRate
                            character={<StarOutlined />}
                            onChange={value => changeRatingHandler(question.id, value, forumQuestions.length)}
                        />
                    )}
                </Box>
            );
        });

        panelImpression = (
            <>
                <TitleSeparator back>{strings.panel.HEADER}</TitleSeparator>
                <DivWithScrollY>
                    <PanelHeader id={id} />
                    <StyledLabelAndSendButton paddingX={[3, 4]}>
                        <StyledLabel>{strings.panel.IMPRESSION}</StyledLabel>
                        {!answers && (
                            <StyledSendButton disabled={disabledSendButton} type="default" onClick={sendButtonListener}>
                                {strings.panel.IMPRESSION_BUTTON}
                            </StyledSendButton>
                        )}
                    </StyledLabelAndSendButton>
                    <StyledQuestions paddingX={[3, 4]}>{questions}</StyledQuestions>
                    <Box paddingX={[3, 4]} paddingY={[1, 3]}>
                        {forumPanels[id].impression.answers ? (
                            <StyledComment
                                rows="6"
                                maxLength="512"
                                disabled="true"
                                value={comment ? comment : ""}
                                onChange={event => setComment(event.target.value)}
                            />
                        ) : (
                            <StyledComment
                                rows="6"
                                maxLength="512"
                                defaultValue={comment}
                                placeholder={strings.panel.IMPRESSION_COMMENT_PLACEHOLDER}
                                onChange={event => setComment(event.target.value)}
                            />
                        )}
                    </Box>
                </DivWithScrollY>
            </>
        );
    }

    return <div style={{ height: "100%" }}>{panelImpression}</div>;
};

export default PanelImpression;
